import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var selectComponentName = 'QuantumSelect';
export function getSelectUtilityClass(slot) {
    return generateUtilityClass(selectComponentName, slot);
}
export var selectClasses = generateUtilityClasses(selectComponentName, [
    'root',
    'select',
    'clearInputAdornment',
    'clearButton',
    'prefixInputAdornment',
    'prefixText',
    'selectMenu',
]);
